import {observer} from 'mobx-react';
import React from 'react';
import {useStores} from '../../../../../../hooks';
import {MenuFormType} from '../../../../store/generalMenuStore/forms';
import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import {Button, Typography} from '../../../../../../common/components/libs';
import {useHistory} from 'react-router';

const TariffExpiresForm = () => {
    const { generalMenuStore, authStore } = useStores()
    const { forms } = generalMenuStore;
    const { open, current } = forms.forms[MenuFormType.tariffExpiresForm];
    const history = useHistory()

    const closeForm = () => {
        forms.closeForm(MenuFormType.tariffExpiresForm)
    };

    if (!current) return <></>

    const toTariffs = () => {
        history.push('/documents/tariff')
        closeForm()
    }

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">
                <Typography variant={'h4'} align={"center"}>
                    {authStore.isTariffOverdue() ? "Ваш тариф просрочен" : "Тариф истёк"}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {authStore.isTariffOverdue() ? (
                    <Typography variant={'subtitle2'}>
                        Меню станут неактивны через {authStore.menusAliveStr()}
                    </Typography>
                ) : (
                    <Typography variant={'subtitle2'}>
                        Для включения меню, подключите один из тарифов
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button color='primary' variant='contained' onClick={() => toTariffs()}>
                    К тарифам
                </Button>
                <Button onClick={closeForm}
                        color="primary"
                >
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default observer(TariffExpiresForm)